import CostSharing from "./CostSharing";
import { SLOT_NAMES } from "../../../utils/constants";

const step = 13
const StepThirteen = ({ activeStep, control, errors, setValue, getValues }) => {
    if (activeStep !== step) return;

    const template = getValues("template")
    const baseName = 'costShareBenefitDetails.physicianServices';
    const services = [
        {
            title: 'Telemedicine',
            name: `${baseName}.telemedicine.type`,
            inNetworkName: `${baseName}.telemedicine.inNetwork`,
            outOfNetworkName: `${baseName}.telemedicine.outOfNetwork`,
            category: SLOT_NAMES.TELEMEDICINE_TELEHEALTH
        },
        //todo consolidate all four to one pcpOfficeVisit behavioralAnalysisTreatment obgynVisit specialistVisit
        {
            title: 'Physician Services',
            name: `${baseName}.physicianServices.type`,
            inNetworkName: `${baseName}.physicianServices.inNetwork`,
            outOfNetworkName: `${baseName}.physicianServices.outOfNetwork`,
            category: SLOT_NAMES.PHYSICIAN_SERVICES
        },
        {
            title: 'Behavioral Health',
            name: `${baseName}.behavioralHealth.type`,
            inNetworkName: `${baseName}.behavioralHealth.inNetwork`,
            outOfNetworkName: `${baseName}.behavioralHealth.outOfNetwork`,
            category: SLOT_NAMES.BEHAVIORAL_HEALTH,
        },
        {
            title: 'Allergy Services',
            name: `${baseName}.allergyServices.type`,
            inNetworkName: `${baseName}.allergyServices.inNetwork`,
            outOfNetworkName: `${baseName}.allergyServices.outOfNetwork`,
            category: SLOT_NAMES.ALLERGY_SERVICES
        },
        {
            title: 'Therapy Services',
            name: `${baseName}.therapyServices.type`,
            inNetworkName: `${baseName}.therapyServices.inNetwork`,
            outOfNetworkName: `${baseName}.therapyServices.outOfNetwork`,
            category: SLOT_NAMES.THERAPY,
            searchText: ""
        },
        {
            title: 'Urgent Care / Walk-In Retail Clinic',
            name: `${baseName}.urgentCare.type`,
            inNetworkName: `${baseName}.urgentCare.inNetwork`,
            outOfNetworkName: `${baseName}.urgentCare.outOfNetwork`,
            category: SLOT_NAMES.URGENT_CARE
        },
        {
            title: 'Chiropractic',
            name: `${baseName}.chiropractic.type`,
            inNetworkName: `${baseName}.chiropractic.inNetwork`,
            outOfNetworkName: `${baseName}.chiropractic.outOfNetwork`,
            category: SLOT_NAMES.CHIROPRACTIC
        },
        {
            title: 'Alternative Therapy /  Acupuncture',
            name: `${baseName}.acupuncture.type`,
            inNetworkName: `${baseName}.acupuncture.inNetwork`,
            outOfNetworkName: `${baseName}.acupuncture.outOfNetwork`,
            category: SLOT_NAMES.ALTERNATIVE_THERAPY
        },
        {
            title: 'Nutritional Counseling',
            name: `${baseName}.nutritionalCounseling.type`,
            inNetworkName: `${baseName}.nutritionalCounseling.inNetwork`,
            outOfNetworkName: `${baseName}.nutritionalCounseling.outOfNetwork`,
            category: SLOT_NAMES.NUTRITIONAL_COUNSELING
        },
        {
            title: 'Reproductive Services',
            name: `${baseName}.reproductiveServices.type`,
            inNetworkName: `${baseName}.reproductiveServices.inNetwork`,
            outOfNetworkName: `${baseName}.reproductiveServices.outOfNetwork`,
            category: SLOT_NAMES.REPRODUCTIVE_SERVICES_INFERTILITY
        },
        {
            title: 'Diabetic Services',
            name: `${baseName}.diabeticServices.type`,
            inNetworkName: `${baseName}.diabeticServices.inNetwork`,
            outOfNetworkName: `${baseName}.diabeticServices.outOfNetwork`,
            category: SLOT_NAMES.DIABETIC_SERVICES
        },
    ].sort((a, b) => a.title?.localeCompare(b.title))

    return (
        <>
            {services?.map(serv => {
                return <div className="cost-sharing-box" key={serv.title}>
                    <CostSharing
                        name={serv.name}
                        title={serv.title}
                        category={serv.category}
                        searchText={serv.searchText}
                        filterText={serv.filterText}
                        template={template}
                        inNetworkName={serv.inNetworkName}
                        outOfNetworkName={serv.outOfNetworkName}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                    />
                </div>
            })}
        </>
    )
}

export default StepThirteen
